import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ThemeMetadataContext = /*#__PURE__*/createContext({
  themeName: 'classic',
  themeMode: 'light'
});
export const ThemeMetadataContextProvider = ({
  themeName,
  themeMode,
  children
}) => {
  const memoizedValue = useMemo(() => {
    return {
      themeName,
      themeMode
    };
  }, [themeName, themeMode]);
  return /*#__PURE__*/_jsx(ThemeMetadataContext.Provider, {
    value: memoizedValue,
    children: children
  });
};

/**
 * Provides the context for theme metadata.
 * @returns themeMetadataContext - The theme metadata object.
 * @returns themeMetadataContext.themeName - The theme name.
 * @returns themeMetadataContext.themeMode - The theme mode.
 */
export const useThemeMetadata = () => {
  const themeMetadataContext = useContext(ThemeMetadataContext);
  return themeMetadataContext;
};